import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { NgStyle } from '@angular/common';
import { ThemePipe } from '../../../core/pipes/theme.pipe';
import { IconComponent } from '../../icon/icon/icon.component';
import { CurrencyAmountComponent } from '../../currency/currency-amount/currency-amount.component';
import { CurrencyAmountDisplay } from '../../../shared/utils/currency/currency-format';

/**
 * A text button with no fill: a label, an optional amount after it and an optional forward
 * arrow ("Play now →", "Play $0.25 →", "Results"). Styled by the `button.wager-link.*` tokens.
 *
 * It often sits inside a clickable card, so a tap is kept from bubbling to the card: the card
 * would otherwise handle the same tap a second time. Such a card should not itself be a
 * `role="button"` (a button nested in a button), and it sets `--link-button-feedback: none`
 * so its own hover/press brightening isn't doubled by the button's.
 */
@Component({
  selector: 'app-link-button',
  templateUrl: './link-button.component.html',
  styleUrls: ['./link-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgStyle, ThemePipe, IconComponent, CurrencyAmountComponent],
})
export class LinkButtonComponent {
  readonly label = input.required<string>();
  readonly amount = input<CurrencyAmountDisplay>();
  readonly arrow = input(false);
  readonly disabled = input(false);

  readonly clickEvent = output<void>();

  readonly labelStyles: [string, string][] = [
    ['type', 'button-wager-link-label'],
    ['text-color', 'button-wager-link-label'],
  ];

  onClick(event: Event): void {
    event.stopPropagation();
    if (!this.disabled()) {
      this.clickEvent.emit();
    }
  }
}
